import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsFHEPool(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsFHEPool(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsFHEPool - ', e);
                throw e;
            });
    };
}
export { getLogsFHEPool };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsFHEPool/actions.js